enum businessDocumentType {
    invoice = 0x0001,
    goodsIssue = 0x0002
}

export default businessDocumentType;
